import React, { Component } from "react"
import { Input, Button, Checkbox } from "antd"
import { Icon } from "@ant-design/compatible"
import { config } from "rxjs"
import SurveyConfigPreview from "../SurveyConfigPreview"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

class ThirdStepConfig extends Component {
  renderCells = (color) => {
    const cells = []
    let i = 1
    while (i <= 5) {
      cells.push(
        <div style={{ borderColor: color, color }} key={i}>
          {i}
        </div>
      )
      i++
    }

    return cells
  }

  hideFooter = () => {
    const { configSurvey } = this.props

    return (
      this.props.display_number === configSurvey.display_number &&
      this.props.order_random === configSurvey.order_random &&
      this.props.display_progress_bar === configSurvey.display_progress_bar &&
      this.props.likert_text_left === configSurvey.likert_text_left &&
      this.props.likert_text_center === configSurvey.likert_text_center &&
      this.props.likert_text_right === configSurvey.likert_text_right
    )
  }

  render() {
    return (
      <div className="first-step-container">
        <div style={{ minHeight: 734 }}>
          <div className="first-step-container-title">PREFERENCIAS</div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Numeración preguntas</span>
            <Checkbox
              className="checkbox-survey-config"
              checked={this.props.display_number}
              onChange={(e) =>
                this.props.setStateFrom("display_number", e.target.checked)
              }
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Orden aleatorio de preguntas</span>
            <Checkbox
              className="checkbox-survey-config"
              checked={this.props.order_random}
              onChange={(e) =>
                this.props.setStateFrom("order_random", e.target.checked)
              }
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal">
            <span>Barra de progreso</span>
            <Checkbox
              checked={this.props.display_progress_bar}
              onChange={(e) =>
                this.props.setStateFrom(
                  "display_progress_bar",
                  e.target.checked
                )
              }
              className="checkbox-survey-config"
            />
          </div>
          <div className="first-step-container-title" style={{ marginTop: 8 }}>
            ESCALA DE LIKERT
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Texto extremo izquierdo</span>
            <Input
              maxLength={30}
              value={this.props.likert_text_left}
              onChange={(e) =>
                this.props.setStateFrom("likert_text_left", e.target.value)
              }
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Texto centro</span>
            <Input
              maxLength={30}
              value={this.props.likert_text_center}
              onChange={(e) =>
                this.props.setStateFrom("likert_text_center", e.target.value)
              }
            />
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Texto extremo derecho</span>
            <Input
              maxLength={30}
              value={this.props.likert_text_right}
              onChange={(e) =>
                this.props.setStateFrom("likert_text_right", e.target.value)
              }
            />
          </div>
          {!this.hideFooter() && (
            <div className="footer-survey-config">
              <Button onClick={this.props.updateAllState}>Cancelar</Button>
              <Button
                disabled={
                  !this.props.likert_text_left || !this.props.likert_text_right
                }
                type="primary"
                onClick={() => {
                  const {
                    display_number,
                    display_progress_bar,
                    order_random,
                    likert_text_center,
                    likert_text_left,
                    likert_text_right,
                  } = this.props

                  woopraTrack(
                    "Guardar configuración de preferencias cuestionario"
                  )
                  const params = {
                    idSurvey: this.props.id_survey,
                    editSettingSegment: this.props.editSettingSegment,
                    params: {
                      display_number: Number(display_number),
                      display_progress_bar: Number(display_progress_bar),
                      order_random: Number(order_random),
                      likert_text_center,
                      likert_text_left,
                      likert_text_right,
                    },
                  }

                  this.props.updateConfigSurveyWatcher(params)
                }}>
                Guardar
              </Button>
            </div>
          )}
        </div>
        <SurveyConfigPreview {...this.props} />
      </div>
    )
  }
}

export default ThirdStepConfig
